var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"follower-box"},[_c('ul',_vm._l((_vm.getData),function(item){return _c('li',[_c('a',[_c('div',{staticClass:"img",style:({background: 'url('+ item.avatar_url +')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.login))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc6383ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/data/dright/follower.vue
// module id = null
// module chunks = 